<div class="attribute b-none">
  <label class="bg-white" for="yesno">{{ label }}</label>
  <ng-select
    appendTo="body"
    (change)="onChange()"
    [multiple]="multiple"
    [formControl]="control"
    [searchable]="true"
    [clearable]="false"
    class="custom {{ class }}"
    [placeholder]="placeholder"
    [items]="fullItems"
    labelForId="yesno"
    [bindValue]="bindValue"
    [bindLabel]="bindLabel"
  >
    <ng-template ng-label-tmp let-item="item">
      <span
        *ngIf="item?.businessCategory && optionTag == 'businessCategory'"
        style="padding: 3px"
        class="mx-1"
        [ngClass]="{
          'self-product': item?.businessCategory[0] == 'C',
          'third-product': item?.businessCategory[0] == 'L',
          'master-product': item?.businessCategory[0] == 'P'
        }"
      >
        {{ item?.businessCategory[0] }}
      </span>
      <span>{{ item[bindLabel] }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div class="ng-option-label">
        <span
          *ngIf="optionTag == 'businessCategory'"
          style="padding: 3px"
          class="mx-1"
          [ngClass]="{
            'self-product': item?.businessCategory[0] == 'C',
            'third-product': item?.businessCategory[0] == 'L',
            'master-product': item?.businessCategory[0] == 'P'
          }"
        >
          {{ item?.businessCategory[0] }}
        </span>
        <span>{{ item[bindLabel] }}</span>
      </div>
    </ng-template>
  </ng-select>
</div>
